var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0834 2.33325H10.0334C9.56675 2.33325 9.10008 2.56659 8.75008 2.91659C8.40008 3.26659 8.16675 3.73325 8.16675 4.19992V19.1333C8.16675 19.5999 8.40008 20.0666 8.75008 20.4166C9.10008 20.7666 9.56675 20.9999 10.0334 20.9999H21.4667C21.9334 20.9999 22.4001 20.7666 22.7501 20.4166C23.1001 20.0666 23.3334 19.5999 23.3334 19.1333V7.58325L18.0834 2.33325Z",
    stroke: "white",
    strokeWidth: 1.62376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.86658V23.7999C3.5 24.2666 3.73333 24.7332 4.08333 25.0832C4.43333 25.4332 4.9 25.6666 5.36667 25.6666H16.8",
    stroke: "white",
    strokeWidth: 1.62376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.33325V8.16659H23.3333",
    stroke: "white",
    strokeWidth: 1.62376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c3516ce720f93408a93db289e3ed6e3f.svg";
export { ForwardRef as ReactComponent };